import { useEffect, useState } from "react";
import { useReducedMotion } from "framer-motion";

export const TEXT_ANIMS = [
  ["slide-up", "Slide up"], ["fade", "Fade"], ["slide-left", "Slide in"], ["zoom", "Zoom"], ["typewriter", "Typewriter"],
];

// Inline colours for a slide's buttons (0 = main filled button, 1 = outline button); empty = default look
export const heroBtnStyle = (sl, i) => {
  if (i === 0) return { ...(sl.btn_bg ? { backgroundColor: sl.btn_bg } : {}), ...(sl.btn_text ? { color: sl.btn_text } : {}) };
  return sl.btn2_color ? { color: sl.btn2_color, borderColor: sl.btn2_color } : undefined;
};

// framer-motion props for how a slide's text block enters
export const animProps = (kind) => ({
  fade: { initial: { opacity: 0 }, animate: { opacity: 1 } },
  "slide-left": { initial: { opacity: 0, x: -40 }, animate: { opacity: 1, x: 0 } },
  zoom: { initial: { opacity: 0, scale: 0.92 }, animate: { opacity: 1, scale: 1 } },
  typewriter: { initial: { opacity: 1 }, animate: { opacity: 1 } },
}[kind] || { initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 } });

// Types the two headline lines out letter by letter (untyped letters stay invisible so nothing jumps)
export function TypedTitle({ line1, line2, run, line1Props = {}, line2Props = {} }) {
  const reduce = useReducedMotion();
  const total = line1.length + line2.length;
  const [n, setN] = useState(run && !reduce ? 0 : total);
  useEffect(() => {
    if (!run || reduce) { setN(total); return undefined; }
    setN(0);
    const step = Math.max(25, Math.min(60, 1400 / Math.max(1, total)));
    const t = setInterval(() => setN((v) => { if (v >= total) { clearInterval(t); return v; } return v + 1; }), step);
    return () => clearInterval(t);
  }, [line1, line2, run, reduce, total]);
  const k1 = Math.min(n, line1.length), k2 = Math.max(0, n - line1.length);
  return (
    <>
      <span {...line1Props}>{line1.slice(0, k1)}<span className="opacity-0">{line1.slice(k1)}</span></span><br />
      <span {...line2Props}>{line2.slice(0, k2)}<span className="opacity-0">{line2.slice(k2)}</span></span>
    </>
  );
}
